import React from "react"
import { ButtonLink, SEO } from "shared/components"
import styled from "styled-components"
import { Layout, PageHero, Title1, Title2, Title3VariableTextSize, Wrapper } from "../components"
import heroImage from "../images/gray-and-lilac-master-bedroom-PKZE7LQ.jpg"
import mattress3 from "../images/mattress-3.jpg"
import { PRIMARY_COLOR_100, WHITE_COLOR } from "../styles"


const ProductSection = styled.section`
  display: flex;
  justify-content: center;
  padding: 100px 0;
`

const Product = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-width: 500px;
`

const Products = () => (
  <Layout>
    <SEO title="Cuzy | Products" description="Cuzy Products" />
    <PageHero
      backgroundImage={ heroImage }
      positionY="70%"
      // tslint:disable-next-line: jsx-no-lambda
      renderContent={ () => (
        <div className="flex flex-col items-center pt-20">
          <Title1 className="text-center mb-5">Our Mattress Collection</Title1>
          <Title3VariableTextSize textSize="1.5rem" className="text-primary-100 font-bold text-center">Shop our best selling sleep products.</Title3VariableTextSize>
        </div>
      ) }
    />
    <Wrapper>
      <ProductSection>
        <Product>
          <img src={ mattress3 } alt="Our mattress in a box!" className="mb-5" />
          <Title2 className="mb-5 text-center">CUZY - Mattress In A Box</Title2>
          <p className="mb-5 text-center">$399.00 - $699.00</p>
          <ButtonLink
            className="mb-5 rounded-full"
            color={ PRIMARY_COLOR_100 }
            colorHover={ WHITE_COLOR }
            borderColor={ PRIMARY_COLOR_100 }
            borderColorHover={ PRIMARY_COLOR_100 }
            textColor={ WHITE_COLOR }
            textColorHover={ PRIMARY_COLOR_100 }
            href="https://shop.cuzy.ca/product/cuzy-mattress-in-a-box/"
          >
            Select Option
          </ButtonLink>
        </Product>
      </ProductSection>
    </Wrapper>
  </Layout>
)

export default Products
